'use client'

import { startNewConversation } from '@/app/_messenger/actions'
import { useMessengerState } from '@/app/_messenger/hooks/useMessengerState'
import { Button } from '@/app/_primitives/Button'
import { toast } from '@/app/_primitives/Toast'
import { cn } from '@/app/utils'
import { useCurrentLocale, useI18n } from '@/locales/client'
import { useRouter } from 'next/navigation'
import { useCallback, useState } from 'react'

export default function ContactButton({
  characterId,
  isLoggedIn,
  isHero,
  isSelfBrowsing,
  isHeroSmall,
  className,
}: {
  isLoggedIn: boolean
  characterId: string
  isHero: boolean
  isHeroSmall?: boolean
  isSelfBrowsing: boolean
  className?: string
}) {
  const router = useRouter()
  const [, setMessengerState] = useMessengerState()
  const [loading, setLoading] = useState(false)
  const t = useI18n()
  const isKorean = Boolean(useCurrentLocale() === 'ko')

  const contactCharacter = useCallback(async () => {
    if (isSelfBrowsing) return

    if (!isLoggedIn) {
      router.push(`/login`)
    }

    setLoading(true)

    const conversation = await toast.promise(
      startNewConversation({
        characterCode: characterId,
      }),
      {
        loading: { title: '채팅을 시작합니다...', content: '' },
        success: { title: '채팅을 시작합니다.', content: '' },
        error: {
          title: '서버가 불안정합니다. 잠시 후 다시 시도해주세요.',
          content: '',
        },
      },
    )

    if (conversation === null || !conversation) {
      setLoading(false)

      return
    }

    window.scroll({
      top: 0,
      behavior: 'smooth',
    })
    setMessengerState((draft) => {
      draft.open = true
      draft.selectedConversationId = conversation.conversation.id
    })

    setLoading(false)
  }, [characterId, isLoggedIn, router, setMessengerState, isSelfBrowsing])

  if (isHero) {
    return (
      <Button
        type="button"
        color="butterScotch"
        size={'default'}
        className={cn(
          `hidden xl:block`,
          !isKorean ? 'xl:w-auto xl:min-w-218' : `xl:w-218`,
        )}
        loading={loading}
        disabled={loading || isSelfBrowsing}
        onClick={contactCharacter}>
        {t('common.charUseInquiryLabel')}
      </Button>
    )
  }

  if (isHeroSmall) {
    return (
      <Button
        type="button"
        color="butterScotch"
        className={`w-full xl:hidden ` + className}
        loading={loading}
        disabled={loading || isSelfBrowsing}
        onClick={contactCharacter}>
        {t('common.charUseInquiryLabel')}
      </Button>
    )
  }

  return (
    <Button
      type="button"
      color="butterScotch"
      className={cn(
        `w-full`,
        !isKorean ? `xl:w-auto xl:min-w-166` : `xl:w-166`,
      )}
      loading={loading}
      disabled={loading || isSelfBrowsing}
      onClick={contactCharacter}>
      {t('common.charUseInquiryLabel')}
    </Button>
  )
}
